import { defineMessages } from 'react-intl';

export default defineMessages({
  remittance: {
    id: 'app.modules.remittance.mainPage.remittance',
    defaultMessage: 'Remittance',
  },
  calculateRemittance: {
    id: 'app.modules.remittance.mainPage.calculateRemittance',
    defaultMessage: 'Calculate Remittance',
  },
  commercehubLabel: {
    id: 'app.modules.remittance.bank-code.commercehub',
    defaultMessage: 'Commercehub',
  },
  itransactLabel: {
    id: 'app.modules.remittance.bank-code.itransact',
    defaultMessage: 'ITransact',
  },
  zionsLabel: {
    id: 'app.modules.corporate-settings.bank.zions',
    defaultMessage: 'Zions',
  },
  finalizedLabel: {
    id: 'app.modules.remittance.bank-code.finalized',
    defaultMessage: 'Finalized',
  },
  notFinalizedLabel: {
    id: 'app.modules.remittance.bank-code.notFinalized',
    defaultMessage: 'Not Finalized',
  },
  generatedLabel: {
    id: 'app.modules.remittance.bank-code.generated',
    defaultMessage: 'Generated',
  },
  stagingLabel: {
    id: 'app.modules.remittance.bank-code.staging',
    defaultMessage: 'Staging',
  },
  submittedLabel: {
    id: 'app.modules.remittance.bank-code.submitted',
    defaultMessage: 'Submitted',
  },
  canceledLabel: {
    id: 'app.modules.remittance.bank-code.canceled',
    defaultMessage: 'Canceled',
  },
  finalizeLabel: {
    id: 'app.modules.remittance.bank-code.Finalize',
    defaultMessage: 'Finalize',
  },
  skippedNamesModalTitle: {
    id: 'app.modules.remittance.skippedNamesModalTitle',
    defaultMessage: 'Remittance Calculation',
  },
  skippedNamesModalHeader: {
    id: 'app.modules.remittance.skippedNamesModalHeader',
    defaultMessage:
      'Remittance have not been calculated and skipped in NACHA file for such {items}:',
  },
  skippedNamesModalHeaderClubsAndCorps: {
    id: 'app.modules.remittance.skippedNamesModalHeaderClubsAndCorps',
    defaultMessage: 'corporations and clubs',
  },
  skippedNamesModalFooter: {
    id: 'app.modules.remittance.skippedNamesModalFooter',
    defaultMessage: 'Please setup Bank info fields and try again.',
  },
});
